<template>
  <v-card class="info-page rounded-xl bg-surface border border-white-05 pa-8 mb-10">
    <div class="text-h3 font-weight-black mb-6 text-primary">Frequently Asked Questions</div>
    
    <v-expansion-panels variant="accordion" class="custom-panels">
      <v-expansion-panel class="bg-transparent border-b border-white-05">
        <v-expansion-panel-title class="text-h6 font-weight-bold py-4">
          How do I log in?
        </v-expansion-panel-title>
        <v-expansion-panel-text class="text-grey-lighten-1">
          Simply use your existing Bluesky account credentials. We support OAuth for secure authentication, meaning we never see your password.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel class="bg-transparent border-b border-white-05">
        <v-expansion-panel-title class="text-h6 font-weight-bold py-4">
          What is "Ludography"?
        </v-expansion-panel-title>
        <v-expansion-panel-text class="text-grey-lighten-1">
          A Ludography is a list of games you've worked on. Our system integrates with IGDB, allowing you to easily add titles, platforms, and artwork to your professional profile.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel class="bg-transparent border-b border-white-05">
        <v-expansion-panel-title class="text-h6 font-weight-bold py-4">
          Where are my posts stored?
        </v-expansion-panel-title>
        <v-expansion-panel-text class="text-grey-lighten-1">
          All your posts and interactions are stored on the AT Protocol (Bluesky). Gamedev.id is a client that provides a specialized view of this data. If you post here, it will show up on bsky.app and other clients as well.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel class="bg-transparent border-b border-white-05">
        <v-expansion-panel-title class="text-h6 font-weight-bold py-4">
          Is Gamedev.id free?
        </v-expansion-panel-title>
        <v-expansion-panel-text class="text-grey-lighten-1">
          Yes! Gamedev.id is a community project and is free to use.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel class="bg-transparent border-b border-white-05">
        <v-expansion-panel-title class="text-h6 font-weight-bold py-4">
          Why I couldn't find (someone's) post here?
        </v-expansion-panel-title>
        <v-expansion-panel-text class="text-grey-lighten-1">
          As a safety measure for the gamedev community, there is a global block list which is strictly enforced. 
          You can see the current <a href="#" @click.prevent="router.push('/blocklist')" class="text-primary font-weight-bold">Blocklist here</a>.
          <div class="mt-4">
            If you believe there is a mistake, or if you want to suggest adding an account to the block list, please contact the administrator ({{ adminHandle }}).
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="mt-10">
      <v-btn color="primary" variant="text" class="text-none font-weight-black" @click="$emit('back')">
        <v-icon start icon="mdi-arrow-left"></v-icon> Back to Feed
      </v-btn>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

defineEmits(['back']);
const router = useRouter();
const adminHandle = import.meta.env.VITE_BSKY_ADMIN || 'igrir.bsky.social';
</script>

<style scoped>
.info-page {
  max-width: 800px;
  margin: 0 auto;
}
.custom-panels :deep(.v-expansion-panel-title) {
  min-height: 64px;
}
.custom-panels :deep(.v-expansion-panel--active > .v-expansion-panel-title) {
  color: var(--v-theme-primary);
}
</style>
